import { render, staticRenderFns } from "./TeachingProfileForm.vue?vue&type=template&id=1a1e9c5a&scoped=true"
import script from "./TeachingProfileForm.vue?vue&type=script&lang=js"
export * from "./TeachingProfileForm.vue?vue&type=script&lang=js"
import style0 from "./TeachingProfileForm.vue?vue&type=style&index=0&id=1a1e9c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e9c5a",
  null
  
)

export default component.exports